import { noop } from '../app/utils/utils';

export default {
    Map: noop,
    AttributionControl: noop,
    NavigationControl: noop,
    Marker: noop,
    Popup: noop,
};
